import { FC } from 'react'
import { MediaFieldType, SectionLogosProps } from '@portfolio/models'
import { styled } from '@portfolio/styles'
import { Media, SectionWrapper } from '@portfolio/components'

const StyledSectionWrapper = styled(SectionWrapper, {
  color: '$white',
  display: 'grid',
  justifyItems: 'center',
  gap: '$40',
  paddingTop: '$64',
  containerSpace: 'small',
  maxWidth: '$maxWidthDesktop',
  marginInline: 'auto',

  '@lg': {
    paddingTop: '$96',
  },
})

const Title = styled('h2', {
  textAlign: 'center',
  projectFont: 'heading07',
  letterSpacing: '-0.01em',
})

const LogosList = styled('ul', {
  listStyle: 'none',
  margin: 0,
  padding: 0,
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  justifyItems: 'center',
  alignItems: 'center',
  paddingBlock: '$8',
  rowGap: '$64',

  '@md': {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    rowGap: '$32',
    columnGap: '$48',
  },
})

const LogoItem = styled('li', {
  position: 'relative',
  maxWidth: '100%',
  lin: {
    height: [20, 30],
  },
})

const getLogoAspectRatio = (image?: MediaFieldType) => {
  const payload = image?.mediaPayload

  if (payload?.type !== 'sanity-image') {
    return undefined
  }

  const { width, height } = payload.image
  return width && height ? `${width} / ${height}` : undefined
}

export const SectionLogos: FC<SectionLogosProps> = ({
  title,
  logos,
  spacing,
  topBorder,
}) => {
  if (!logos || logos.length === 0) {
    return null
  }

  return (
    <StyledSectionWrapper type={spacing || 'DEFAULT'} topBorder={topBorder}>
      {title && <Title>{title}</Title>}
      <LogosList>
        {logos.map((logo) => {
          const aspectRatio = getLogoAspectRatio(logo.image)

          if (!logo.image || !aspectRatio) {
            return null
          }

          return (
            <LogoItem key={logo._key} css={{ aspectRatio }}>
              <Media
                {...logo.image}
                layout="fill"
                objectFit="contain"
                sizes="250px"
                disablePlaceholderBackground
              />
            </LogoItem>
          )
        })}
      </LogosList>
    </StyledSectionWrapper>
  )
}
